import { ExecuteCaptcha } from "./executeCaptcha.interface"
import { logger } from "@/utils/logger"
import { parseAPIError } from "@/utils/parseAPIError"

export const executeCaptcha: ExecuteCaptcha = async (action, captchaSiteKey) => {
  try {
    logger.debug("[Action:Started] Execute Captcha", { action })
    const captchaResponse = await window.grecaptcha.execute(captchaSiteKey, {
      action,
    })
    return [captchaResponse, null] as const
  } catch (_err) {
    const error = await parseAPIError(_err)
    logger.error(`[Action:Error] Execute Captcha (${error.description})`)
    return [null, "CAPTCHA_FAILED"] as const
  }
}
